// Utility to format numbers with thousands separator and suffixes (K, M, B, T, Q, etc)
export function formatNumber(num: number): string {
  if (num === null || num === undefined || isNaN(num)) return '0';
  const absNum = Math.abs(num);
  
  // Format large numbers with suffixes and thousand separators
  if (absNum >= 1e15) {
    const formattedNum = (num / 1e15).toLocaleString('en-US', { maximumFractionDigits: 2 });
    return formattedNum.replace(/\.00$/, '') + 'Q'; // Quadrillion
  }
  if (absNum >= 1e12) {
    const formattedNum = (num / 1e12).toLocaleString('en-US', { maximumFractionDigits: 2 });
    return formattedNum.replace(/\.00$/, '') + 'T'; // Trillion
  }
  if (absNum >= 1e9) {
    const formattedNum = (num / 1e9).toLocaleString('en-US', { maximumFractionDigits: 2 });
    return formattedNum.replace(/\.00$/, '') + 'B'; // Billion
  }
  if (absNum >= 1e6) {
    const formattedNum = (num / 1e6).toLocaleString('en-US', { maximumFractionDigits: 2 });
    return formattedNum.replace(/\.00$/, '') + 'M'; // Million
  }
  if (absNum >= 1e3) {
    const formattedNum = (num / 1e3).toLocaleString('en-US', { maximumFractionDigits: 1 });
    return formattedNum.replace(/\.0$/, '') + 'K'; // Thousand
  }
  
  // For smaller numbers, just add thousand separators without decimals
  return num.toLocaleString('en-US', { maximumFractionDigits: 0 });
}
